// extracted by mini-css-extract-plugin
export var rating = "filter-module__rating___MzflF";